import React, { useContext } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import ModalWrapper from 'lib/components/ModalWrapper'
import FormInput from 'lib/components/FormInput'
import { DEFAULT_ORG_PROGRAMS_PATH } from 'lib/api/apiConstants'
import { RouterContext } from 'domains/application/screens/AppScreen'
import { RouteComponentProps } from 'react-router'
import { addDoc } from 'lib/api/connection'

interface IProps {
  isOpen: boolean
  close: () => any
}

interface IFormValues {
  title: string
}

const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required('Required')
    .min(2, 'Come on, give it a longer name'),
})

export default function CreateProgramModal(props: IProps) {
  const router = useContext(RouterContext) as RouteComponentProps

  const onSave = async (values: IFormValues) => {
    try {
      const v2 = await addDoc<any>(DEFAULT_ORG_PROGRAMS_PATH, {
        ...values,
        published: false,
      })
      router.history.push(`/programs/${v2.id}`)
      return
    } catch (error) {
      console.error('Failed to create program', { error }) // tslint:disable-line
    }
  }

  return (
    <Formik
      initialValues={{ title: '' }}
      onSubmit={onSave}
      validationSchema={validationSchema}
    >
      {({ values, handleChange, submitForm }) => (
        <ModalWrapper
          title="New Program"
          isOpen={props.isOpen}
          actions={[
            {
              text: 'Create',
              colorScheme: 'green',
              onClick: submitForm,
              extra: { type: 'submit' },
            },
            {
              text: 'Cancel',
              colorScheme: 'gray',
              onClick: props.close,
              extra: { type: 'button' },
            },
          ]}
        >
          <Form>
            <FormInput
              label="Title"
              name="title"
              value={values.title}
              onChange={handleChange}
              placeholder="30 day abs"
            />
          </Form>
        </ModalWrapper>
      )}
    </Formik>
  )
}
